// User Info
export const FETCH_USERINFO_START = 'FETCH_USERINFO_START';
export const SET_USERINFO = 'SET_USERINFO';
export const FETCH_USERINFO_FAILED = 'FETCH_USERINFO_FAILED';

// Change Password
export const POST_CHANGE_PASSWORD_START = 'POST_CHANGE_PASSWORD_START';
export const POST_CHANGE_PASSWORD_SUCCESS = 'POST_CHANGE_PASSWORD_SUCCESS';
export const POST_CHANGE_PASSWORD_FAILED = 'POST_CHANGE_PASSWORD_FAILED';

// Profile Picture
export const SET_PROFILE_PICTURE = 'SET_PROFILE_PICTURE';

// Manager Status
export const SET_IS_MANAGER = 'SET_IS_MANAGER';

// Auth
export const AUTH_ERROR = 'AUTH_ERROR';
export const USER_LOGOUT = 'USER_LOGOUT';
